import React from 'react';
import styled, { ThemeConsumer } from 'styled-components';
import { motion } from 'framer-motion';
import { media } from 'utils';

import ParallaxContainer from 'containers/ParallaxContainer';
import SectionTemplate from 'templates/SectionTemplate';

const HomeWrapper = styled.div`
  ${media.mobileL`
  width:100%;
  margin-top: 60%;
  display:flex;
  flex-direction:column;
  align-items:flex-end;
`}
`;

const StyledParallaxContainer = styled(ParallaxContainer)`
  padding: 2rem 4rem;

  ${media.mobileL`
  padding: 0;
  transform:rotate(-90deg) translateY(360%);
  transform-origin: bottom left;
  `}
`;

const StyledSvg = styled(motion.svg)`
  width: 100%;
  max-width: 519px;
  max-height: 144px;
  overflow: visible;
`;

const Subtitle = styled.h4`
  margin: 0 4rem;
  font-weight: ${({ theme }) => theme.fontWeight.extraBold};
  font-size: ${({ theme }) => theme.fontSize.l};

  ${media.mobileL`
  margin: 1rem 0;
  font-size: ${({ theme }) => theme.fontSize.m};
  text-align: right;
  max-width: 5rem;
  `}
`;

const HeroSection = () => (
  <SectionTemplate id="home">
    <HomeWrapper>
      <StyledParallaxContainer
        translateRange={[-20, 20]}
        rotateXRange={[-10, 10]}
        rotateYRange={[9, -9]}
      >
        {({ translateX, translateY, rotateX, rotateY }) => (
          <ThemeConsumer>
            {(theme) => (
              <StyledSvg
                fill="none"
                viewBox="0 0 519 144"
                xmlns="http://www.w3.org/2000/svg"
                style={{ rotateX, rotateY }}
              >
                <g>
                  <path
                    d="M375 42.736a5 5 0 012.953-4.561l3.103-1.393a5 5 0 013.563-.203l8.808 2.803c.247.079.488.176.72.292l3.525 1.763c3.03 1.515 3.708 5.54 1.341 7.965l-15.435 15.811c-3.132 3.209-8.578.991-8.578-3.492V42.736z"
                    fill={theme.purple}
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M297.75 94.603c3.303-3.464 3.776-4.276 11.951-2.725 8.174 1.552 20.436 7.494 20.436 7.494s10.483 2.4 10.218 8.174c-.277 6.038-.101 11.084-4.768 14.987-4.638 3.879-16.284 4.831-22.268 4.289-5.871-.532-11.898-2.134-15.569-6.701-3.598-4.477-3.924-10.655-2.964-16.359.88-5.227.37-6.438 2.964-9.159z"
                    fill={theme.orange}
                  />
                  <path fill={theme.red} d="M202 48h19v44h-19z" />
                  <rect
                    x="467"
                    y="63"
                    width="24"
                    height="31"
                    rx="6"
                    fill={theme.red}
                  />
                  <path
                    d="M115.054 70v27.034s-1.367 10.636 9.611 11.966c11.417 0 19.271-9.307 19.321-11.523.05-2.216-.05-27.477-.05-27.477h-28.882z"
                    fill={theme.yellow}
                  />
                  <path
                    d="M23 38h24v18a6 6 0 01-6 6H23V38z"
                    fill={theme.turquoise}
                  />
                </g>
                <motion.path
                  style={{ translateX, translateY }}
                  d="M74.664 116.184c-2.592 1.728-5.736 3.072-9.432 4.032-3.696.96-7.32 1.44-10.872 1.44-8.16 0-14.448-2.136-18.864-6.408s-6.624-9.768-6.624-16.488V53.544H11.448v-9.36h17.424V26.976l12.096-1.44v18.648h26.208l-1.44 9.36H40.968v45.072c0 4.224 1.104 7.44 3.312 9.648 2.256 2.208 5.976 3.312 11.16 3.312 2.832 0 5.448-.336 7.848-1.008 2.4-.672 4.632-1.536 6.696-2.592l4.68 8.208zm38.248-72v53.712c0 4.992 1.032 8.592 3.096 10.8s5.28 3.312 9.648 3.312c4.176 0 8.112-1.176 11.808-3.528 3.744-2.4 6.648-5.232 8.712-8.496v-55.8h12.096V120h-10.296l-1.008-10.224c-2.976 3.84-6.672 6.792-11.088 8.856-4.368 2.016-8.76 3.024-13.176 3.024-7.344 0-12.84-1.944-16.488-5.832-3.6-3.936-5.4-9.432-5.4-16.488V44.184h12.096zM216.68 13.656v87.624c0 3.744 1.152 6.408 3.456 7.992 2.352 1.536 5.376 2.304 9.072 2.304 2.256 0 4.416-.24 6.48-.72 2.112-.48 4.2-1.128 6.264-1.944l3.24 8.856c-2.064 1.008-4.632 1.896-7.704 2.664-3.024.816-6.456 1.224-10.296 1.224-6.72 0-12.168-1.848-16.344-5.544-4.176-3.744-6.264-8.904-6.264-15.48v-77.4h-23.256v-9.576h35.352zm82.599 97.992c5.856 0 10.464-1.08 13.824-3.24 3.36-2.16 5.04-5.088 5.04-8.784 0-2.256-.432-4.224-1.296-5.904-.816-1.68-2.52-3.192-5.112-4.536-2.592-1.392-6.576-2.76-11.952-4.104-5.232-1.296-9.792-2.784-13.68-4.464-3.84-1.728-6.84-3.96-9-6.696-2.112-2.736-3.168-6.288-3.168-10.656 0-6.384 2.664-11.424 7.992-15.12 5.328-3.696 12.264-5.544 20.808-5.544 6.096 0 11.4.816 15.912 2.448 4.56 1.632 8.424 3.6 11.592 5.904l-5.328 8.208c-2.832-1.968-6-3.576-9.504-4.824-3.456-1.296-7.632-1.944-12.528-1.944-5.952 0-10.176.936-12.672 2.808-2.496 1.824-3.744 4.2-3.744 7.128 0 2.256.6 4.128 1.8 5.616 1.248 1.44 3.336 2.736 6.264 3.888 2.928 1.152 6.96 2.424 12.096 3.816 4.944 1.344 9.264 2.928 12.96 4.752 3.696 1.824 6.552 4.224 8.568 7.2 2.064 2.928 3.096 6.744 3.096 11.448 0 5.376-1.536 9.744-4.608 13.104-3.072 3.312-7.056 5.736-11.952 7.272-4.848 1.488-9.984 2.232-15.408 2.232-6.864 0-12.72-.984-17.568-2.952-4.8-2.016-8.832-4.44-12.096-7.272l6.912-7.992c2.976 2.448 6.384 4.44 10.224 5.976 3.888 1.488 8.064 2.232 12.528 2.232zm73.456-99.504V120h-12.096V13.656l12.096-1.512zm50.616 32.04l-34.128 34.128L427.311 120h-15.912l-37.296-41.4 33.552-34.416h15.696zm51.568-35.496c2.688 0 4.824.816 6.408 2.448 1.632 1.632 2.448 3.624 2.448 5.976 0 2.448-.816 4.512-2.448 6.192-1.584 1.632-3.72 2.448-6.408 2.448-2.544 0-4.632-.816-6.264-2.448-1.632-1.68-2.448-3.744-2.448-6.192 0-2.352.816-4.344 2.448-5.976 1.632-1.632 3.72-2.448 6.264-2.448zm9.648 35.496v66.24h21.384V120h-56.88v-9.576h23.4V53.76h-22.68v-9.576h34.776z"
                  fill={theme.secondary}
                />
              </StyledSvg>
            )}
          </ThemeConsumer>
        )}
      </StyledParallaxContainer>
      <Subtitle>home grown dev.</Subtitle>
    </HomeWrapper>
  </SectionTemplate>
);

export default HeroSection;
